import React, { Component } from "react";
import Joi from "joi-browser";
import Input from "./input";
import Textarea from "./textarea";
import Password from "./password";
import Select from "./select";
import SelectUpdate from "./selectUpdate";

class Form extends Component {
  state = {
    data: {},
    errors: {},
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema, { abortEarly: false });
    return error ? error.details[0].message : null;
  };

  setErrors = (input) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);

    if (errorMessage) {
      errors[input.name] = errorMessage;
    } else {
      delete errors[input.name];
    }

    if (input.name === "confirmPassword") {
      if (this.state.data.password === input.value) {
        delete errors[input.name];
      }
    }

    this.setState({ errors });
  };

  setData = (input) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  handleChangeSelect = ({ currentTarget: input }) => {
    this.setErrors(input);
    this.setData(input);
  };

  handleChange = ({ currentTarget: input }) => {
    this.setData(input);
  };

  handleBlur = ({ currentTarget: input }) => {
    this.setErrors(input);
  };

  renderButton(label) {
    return (
      <button disabled={this.validate()} className="btn btn-primary">
        {label}
      </button>
    );
  }

  renderInput(name, label, type = "text", disabled) {
    const { data, errors } = this.state;

    if (name === "mobile") {
      return (
        <Input
          type={type}
          name={name}
          value={data[name]}
          label={label}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          error={errors[name]}
          placeholder="Please enter 10 digit mobile number without country code"
          disabled={disabled}
        />
      );
    } else {
      return (
        <Input
          type={type}
          name={name}
          value={data[name]}
          label={label}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          error={errors[name]}
          disabled={disabled}
        />
      );
    }
  }
  renderSelect(name, label, options, readOnly = false, defaultValue) {
    const { data, errors } = this.state;

    return data[name] ? (
      <SelectUpdate
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChangeSelect}
        error={errors[name]}
        defaultValue={defaultValue}
        readOnly={readOnly}
      />
    ) : (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChangeSelect}
        error={errors[name]}
        defaultValue={defaultValue}
        readOnly={readOnly}
      />
    );
  }

  renderTextarea(name, label, type = "text") {
    const { data, errors } = this.state;

    return (
      <Textarea
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }

  renderPasswordInput(name, label, type = "password") {
    const { data, errors } = this.state;

    return (
      <Password
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }
}

export default Form;
